<mat-card-title>
	Create Account
</mat-card-title>

<div style="padding-top:30px">
	<mat-accordion class="example-headers-align">
		<mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
			<mat-expansion-panel-header>
				<mat-panel-title>
					Personal data
				</mat-panel-title>

				<mat-panel-description>&nbsp;
					<mat-icon>account_circle</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<form [formGroup]="createAccountForm">
				<div class="row">
					<div class="col">
						<div class="row">
							<div class="col">
								<mat-form-field>
									<mat-label>
										First Name
									</mat-label>
									<input matInput type="string" placeholder="First Name"
										formControlName="firstName" />
								</mat-form-field>
							</div>
							<div class="col">
								<mat-form-field>
									<mat-label>M.I.</mat-label>
									<input matInput type="string" placeholder="Middle Initial"
										formControlName="middleInitial" />
								</mat-form-field>
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<div class="col">
								<mat-form-field>
									<mat-label>
										Last Name
									</mat-label>
									<input matInput type="string" placeholder="Last Name" formControlName="lastName" />
								</mat-form-field>
							</div>
							<div class="col">
								<mat-form-field>
									<mat-label>
										Suffix
									</mat-label>
									<mat-select formControlName="suffix">
										<mat-option>No Suffix</mat-option>
										<mat-option *ngFor="let suffix of suffixes" [value]="suffix">
											{{ suffix }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<mat-form-field>
									<mat-label>
										Work Title
									</mat-label>
									<input matInput type="string" placeholder="Work Title"
										formControlName="workTitle" />
								</mat-form-field>
							</div>
							<div class="col"></div>
						</div>
					</div>
					<div></div>
				</div>
				<mat-action-row>
					<button mat-button color="primary" (click)="nextStep()"
						[disabled]="!createAccountForm.valid">Next</button>
				</mat-action-row>
			</form>
		</mat-expansion-panel>

		<mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
			<mat-expansion-panel-header>
				<mat-panel-title>
					Work Information
				</mat-panel-title>
				<mat-panel-description>&nbsp;
					<mat-icon>work</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<form [formGroup]="workDetailsForm">
				<div class="row">
					<div class="col">
						<div class="row">
							<div class="col-lg-8">
								<div class="row">
									<div class="col">
										<mat-form-field>
											<mat-label>
												Work Address 1
											</mat-label>
											<input matInput type="string" placeholder="Street Address 1"
												formControlName="StreetAddress1" />
										</mat-form-field>
									</div>
									<div class="col">
										<mat-form-field>
											<mat-label>Work Address 2</mat-label>
											<input matInput type="string" placeholder="Street Address 2"
												formControlName="StreetAddress2" />
										</mat-form-field>
									</div>
								</div>
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<div class="row">
									<div class="col">
										<input-city-autocomplete [id]="'City'" [name]="'City'" [label]="'City'"
											[placeholder]="'City'" [(selectedCity)]="city" [(state)]="state"
											[required]="true"></input-city-autocomplete>
									</div>
									<div class="col">
										<input-state-autocomplete [id]="'State'" [name]="'State'" [label]="'State'"
											[placeholder]="'State'" [(selectedState)]="state"
											[required]="true"></input-state-autocomplete>
									</div>
								</div>
							</div>
							<div class="col">
								<input-zipcode-autocomplete [id]="'ZIP code'" [name]="'ZIP code'" [label]="'ZIP code'"
									[placeholder]="'ZIP code'" [(selectedZipcode)]="zipcode" [required]="true"
									[countryId]="1">
								</input-zipcode-autocomplete>
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<div class="row">
									<div class="col">
										<mat-form-field>
											<mat-label>
												Work Phone Number
											</mat-label>
											<input matInput type="string" placeholder="workPhoneNumber"
												formControlName="workPhoneNumber" telephoneValidator />
										</mat-form-field>
									</div>
									<div class="col">
										<mat-form-field>
											<mat-label>Ext</mat-label>
											<input matInput type="string" placeholder="Ext" formControlName="ext"
												[numericOnly]="10" />
										</mat-form-field>
									</div>
								</div>
							</div>
							<div class="col"></div>
						</div>
						<div class="row">
							<div class="col-lg-8">
								<div class="row">
									<div class="col">
										<mat-form-field>
											<mat-label>Work Email</mat-label>
											<input matInput placeholder="email@eemail.edu" formControlName="email">
											<mat-error *ngIf="email?.errors?.domainValidator?.invalid">
												{{email?.errors?.domainValidator?.msg}}
											</mat-error>
										</mat-form-field>
									</div>
									<div class="col">
										<mat-form-field>
											<mat-label>Confirm Work Email</mat-label>
											<input matInput placeholder="Confirm email" formControlName="confirmEmail">
											<mat-error *ngIf="confirmEmail?.errors?.emailMustMatch">
												Confirm Email do not match
											</mat-error>
										</mat-form-field>
									</div>
								</div>
							</div>
							<div class="col"></div>
						</div>
					</div>
				</div>
				<mat-action-row>
					<button mat-button color="warn" (click)="prevStep()">Previous</button>
					<button mat-button color="primary" (click)="nextStep()"
						[disabled]="disableTabButton(1)">Next</button>
				</mat-action-row>
			</form>
		</mat-expansion-panel>

		<mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
			<mat-expansion-panel-header>
				<mat-panel-title>
					Region/School Districts and Workplace
				</mat-panel-title>
				<mat-panel-description>&nbsp;
					<mat-icon>work_history</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<div class="row">
				<div class="col">
					<div class="row">
						<div class="col-lg-8">
							<div class="row">
								<div class="col">
									<region-dropdown-two-way [isMultiple]="false" [(selectedRegions)]="selectedRegions"
										[(selectedRegion)]="selectedRegion" [required]="false">
									</region-dropdown-two-way>
								</div>
								<div class="col">
									<input-organization-autocomplete [id]="'Organization'" [name]="'Organization'"
										[label]="'Workplace'" [placeholder]="'Type minimum 3 character to Search..'"
										[(selectedOrganization)]="selectedOrganization" [(region)]="selectedRegion"
										[required]="false"
										[additionalErrorMsg]="'Please search and select a valid Workplace.'">
									</input-organization-autocomplete>
								</div>
							</div>
						</div>
						<div class="col"></div>
					</div>
					<div class="row">
						<div class="col-lg-8">
							<div class="row">
								<div class="col">
									<district-dropdown-two-way [(selectedSchoolDistricts)]="lstSelecteddistricts"
										[required]="false" [isMultiple]="true" [regions]="selectedRegions">
									</district-dropdown-two-way>
								</div>
								<div class="col"></div>
							</div>
						</div>
						<div class="col"></div>
					</div>
					<div class="row">
						<div class="col-lg-12">
							<mat-chip-listbox class="example-chip" cdkDropList cdkDropListOrientation="horizontal">
								<mat-chip-option color="accent" class="example-box" cdkDrag
									*ngFor="let district of lstSelecteddistricts"
									(removed)="removeDistrict(district.ID)">
									{{district.DISTRICTS}}
									<button matChipRemove>
										<mat-icon>cancel</mat-icon>
									</button>
								</mat-chip-option>
							</mat-chip-listbox>
						</div>
					</div>
				</div>
			</div>
			<mat-action-row>
				<button mat-button color="warn" (click)="prevStep()">Previous</button>
				<button mat-button color="primary" (click)="nextStep()" [disabled]="disableTabButton(2)">Next</button>
			</mat-action-row>
		</mat-expansion-panel>

		<mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
			<mat-expansion-panel-header>
				<mat-panel-title>
					Roles
				</mat-panel-title>
				<mat-panel-description>&nbsp;
					<mat-icon>group_add</mat-icon>
				</mat-panel-description>
			</mat-expansion-panel-header>


			<mat-card appearance="outlined">
				<mat-expansion-panel-header>
					<mat-panel-title>
						Please select all that apply
					</mat-panel-title>
				</mat-expansion-panel-header>
				<mat-card-content>
					<div class="row">
						<div *ngFor="let usrRole of lstUserRoles; let i = index" class="col-4">
							<ng-container>
								<mat-checkbox id="role-{{usrRole.role.ID}}" name="role-{{usrRole.role.ID}}"
									[(ngModel)]="usrRole.selected" (change)="onChkChange($event,usrRole.role)">
									{{ usrRole.role.NAME }}
								</mat-checkbox>
							</ng-container>
						</div>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card appearance="outlined">
				<mat-expansion-panel-header>
					<mat-panel-title>
						Approver Roles :
					</mat-panel-title>
				</mat-expansion-panel-header>
				<mat-card-content>
					<div class="row">
						<div *ngFor="let approverRole of lstApproverRole; let i=index" class="col-4">
							<ng-container>
								<mat-checkbox id="role-{{approverRole.role.ID}}" name="role-{{approverRole.role.ID}}"
									[(ngModel)]="approverRole.selected"
									(change)="onChkChange($event,approverRole.role)">
									{{ approverRole.role.NAME }}
								</mat-checkbox>
							</ng-container>
						</div>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-card appearance="outlined">
				<mat-expansion-panel-header>
					<mat-panel-title>
						Administrator Roles
					</mat-panel-title>
				</mat-expansion-panel-header>
				<mat-card-content>
					<div class="row">
						<div *ngFor="let adminRole of lstAdminRoles; let i=index" class="col-4">
							<ng-container>
								<mat-checkbox id="role-{{adminRole.role.ID}}" name="role-{{adminRole.role.ID}}"
									[(ngModel)]="adminRole.selected" (change)="onChkChange($event,adminRole.role)">
									{{ adminRole.role.NAME }}
								</mat-checkbox>
							</ng-container>
						</div>
					</div>
				</mat-card-content>
			</mat-card>

			<mat-action-row>
				<button mat-button color="warn" (click)="prevStep()">Previous</button>
				<button mat-button color="primary" (click)="nextStep()" [disabled]="disableTabButton(10)"
					(click)="createAccount()">
					Save
				</button>
			</mat-action-row>
		</mat-expansion-panel>

	</mat-accordion>
</div>